var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetworkGraphBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.085,
    height: 18.956,
    viewBox: "0 0 18.085 18.956",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(-4.02 -1.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73671",
    "data-name": "Path 73671",
    d: "M19.521,8.893a2.671,2.671,0,0,0-2.456,1.723H13.4a4.265,4.265,0,0,0-.646-1.422l1.508-1.766a3.36,3.36,0,0,0,.948.172,2.585,2.585,0,1,0-2.585-2.585,2.628,2.628,0,0,0,.345,1.292L11.421,8.074A3.662,3.662,0,0,0,9.612,7.6l-.732.086L8.363,6.48A2.585,2.585,0,1,0,6.6,7.169h.172l.56,1.206a3.834,3.834,0,0,0,0,6.2l-.56,1.206H6.6a2.585,2.585,0,1,0,1.766.689l.517-1.206.732.086a3.662,3.662,0,0,0,1.809-.474l1.551,1.766a2.628,2.628,0,0,0-.345,1.292,2.585,2.585,0,1,0,2.585-2.585,3.36,3.36,0,0,0-.948.172l-1.508-1.766a4.265,4.265,0,0,0,.646-1.422h3.662a2.671,2.671,0,0,0,2.456,1.723,2.585,2.585,0,1,0,0-5.17ZM5.735,4.584a.862.862,0,1,1,.862.862A.862.862,0,0,1,5.735,4.584ZM6.6,19.232a.862.862,0,1,1,.862-.862A.862.862,0,0,1,6.6,19.232ZM15.213,4.154a.862.862,0,1,1-.862.862A.862.862,0,0,1,15.213,4.154ZM7.458,11.477a2.154,2.154,0,1,1,2.154,2.154A2.154,2.154,0,0,1,7.458,11.477Zm8.616,6.462a.862.862,0,1,1-.862-.862A.862.862,0,0,1,16.074,17.94Zm3.446-5.6a.862.862,0,1,1,.862-.862A.862.862,0,0,1,19.521,12.339Z",
    transform: "translate(0 0)",
    fill: "#185edf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkGraphBlue);
export default __webpack_public_path__ + "static/media/NetworkGraphBlue.52552be0fd1bb56f943438b76e25a219.svg";
export { ForwardRef as ReactComponent };